import React from "react";
import { Row, Col, Icon, Card, Button } from "antd";
import { StatusBadgeComponent } from "../StatusBadge/StatusBadgeComponent";
import { imageUrlPath } from "../../../components/Settings";
import placeholder from "../../../media/placeholder.png";

export const CreativeComponent = props => {
  const { admaterial, language, tableData } = props;
  return (
    <div className="mobile--card">
      <Card
        size="small"
        extra={
          <Button type="primary" size="small" onClick={props.onClick}>
            <span>{language.data.details}</span>
            <Icon type="caret-right" />
          </Button>
        }
      >
        <Row>
          <Col span={24}>
            <div className="custom--hr" />
          </Col>
          <Col span={6}>
            <img
              src={
                admaterial.preview
                  ? imageUrlPath + admaterial.preview.url
                  : placeholder
              }
              alt="thumbnail"
            />
          </Col>
          <Col span={16} offset={2}>
            <StatusBadgeComponent status={admaterial.status} />
            <ul className="mobile--list">
              {tableData &&
                tableData.map((field, index) => (
                  <li key={index}>
                    <span className="mobile--list--property">
                      {field.prop}
                      {": "}
                    </span>
                    {field.val}
                  </li>
                ))}
            </ul>
          </Col>
        </Row>
        {props.children}
      </Card>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Mobile/Creative/CreativeComponent.js